var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"homeText",style:(("font-size: " + _vm.fontSize + "rem;margin-top:" + _vm.top + "rem;margin-bottom:" + _vm.bottom + "rem;"))},[_vm._v(" "+_vm._s(_vm.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }